<!--
 * @Author: wangkg wangkegui@longfor.com
 * @Date: 2024-05-27 10:06:05
 * @Description:
-->

<template>
  <el-menu
    ref="menu"
    :default-active="defaultActive"
    :mode="mode"
    :router="router"
    :menu-trigger="menuTrigger"
    :background-color="backgroundColor"
    :text-color="textColor"
    :active-text-color="activeTextColor"
  >
    <MenuItem
      v-for="item in menuList"
      :key="item[fieldsMap.id]"
      :index="item[fieldsMap.path]"
      :menu-data="item"
      :fields-map="fieldsMap"
    />
  </el-menu>
</template>
<script>
import MenuItem from './components/menu-item';

// 字段映射
export default {
  name: 'LcMenu',
  components: {
    MenuItem
  },
  props: {
    mode: {
      default: 'horizontal',
      type: String
    },
    backgroundColor: {
      default: '',
      type: String
    },
    textColor: {
      default: '',
      type: String
    },
    activeTextColor: {
      default: '',
      type: String
    },
    router: {
      default: false,
      type: Boolean,
    },
    menuList: {
      default: () => [],
      type: Array
    },
    menuTrigger: {
      default: 'hover',
      type: String
    },
    fieldsMap: {
      default: () => ({
        id: 'id',
        children: 'children',
        path: 'path',
        label: 'label',
        icon: 'icon'
      }),
      type: Object
    },
    defaultActive: {
      default: '',
      type: String
    },

  },
  data() {
    return {
    };
  },
  watch: {
  },
  created() {
  },
  mounted() {
  },
  methods: {
    // preset
  }
};
</script>
